import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import './css/Register.css';
import {IconButton} from "@mui/material";
function LicenseTiersTable() {
    const [licenseTiers, setLicenseTiers] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        fetch('../api/license/getLicenseTiers')
            .then(response => response.json())
            .then(data => setLicenseTiers(data))
            .catch(error => console.error('Error fetching license tiers:', error));
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <div className="Section">
            <div className="SectionLtr">
        <span className="PortalSectionBoxEmbedded">
          <span className="SectionSubHeadingEmbedded">LICENSE TIERS</span>
          <span className="SectionSubHeadingExtraEmbedded">GPU LICENSE PRICING</span>
          <div className="divLineDualGrad"></div>
          <div className="portal-table-container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">GPU Name</TableCell>
                  <TableCell align="center">Average Rented Price</TableCell>
                  <TableCell align="center">License Price</TableCell>
                  <TableCell align="center">Tier</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {licenseTiers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((tier, index) => (
                        <TableRow key={index}>
                            <TableCell align="center">
                                <input value={tier.gpuName} className="tableData" readOnly />
                            </TableCell>
                            <TableCell align="center">
                                <input value={tier.avgRentedPrice.toFixed(3)} className="tableData" readOnly />
                            </TableCell>
                            <TableCell align="center">
                                <input value={`$${tier.licensePrice.toFixed(2)}`} className="tableData" readOnly />
                            </TableCell>
                            <TableCell align="center">
                                <input value={tier.tier} className="tableData" readOnly />
                            </TableCell>
                        </TableRow>
                    ))}
              </TableBody>
            </Table>
          </div>
          <div className="divLineDualGrad"></div>
          <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={licenseTiers.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </span>
            </div>
        </div>
    );
}

export default LicenseTiersTable;
